import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import percentage from "../../../assets/icons/percentage.svg";
import FilterFieldHeader from "../../../components/FilterComponents/FilterFieldHeader";
import OptionalOption from "../../../components/FilterComponents/OptionalOption";
import InputWithIcon from "../../../components/InputWithIcon";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";

const ClosedFilterData = ({ isSidebarOpen, filterData, onSetFilterData , from }) => {
    const [config] = useAuth();
    const [loading, setLoading] = useState(false);
    const [contactData, setContactData] = useState([]);
    const [brokerOptions, setBrokerOptions] = useState([]);

    const handleFilterChange = (value, name) => {
        onSetFilterData({ ...filterData, [name]: value });
    };

    const fetchUsers = () => {
        setLoading(true);
        axios
            .get(`${BASE_URL}/get-datalisting?list=users`, config)
            .then((res) => {
                const data = res?.data?.data;
                const options = data?.map((el) => ({ value: el?.id, label: `${el?.first_name} ${el?.last_name}`, role: el?.role_id }));
                setBrokerOptions(options?.filter((el) => el.role === 3));
            })
            .catch((err) => {
                if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                    NotificationManager.error(err.response?.data?.message);
                }
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (isSidebarOpen) {
            fetchUsers();
        }
    }, [isSidebarOpen]);

    if (from === "closedarchive") {
          return (
            <div>
              <p className="head-4 dark-H">Date Range</p>
      
              <OptionalOption
                activeTab="date"
                onSetLastDate={(value) => onSetFilterData({ ...filterData, count: value })}
                date={filterData?.count}
                onSetDateRange1={(value) =>
                  onSetFilterData({ ...filterData, start_count: value })
                }
                date2={filterData?.start_count}
                onSetDateRange2={(value) =>
                  onSetFilterData({ ...filterData, end_count: value })
                }
                date3={filterData?.end_count}
                onClear={() => {
                  onSetFilterData({
                    ...filterData,
                    count: "",
                    start_count: "",
                    end_count: "",
                  });
                }}
              />
            </div>
          );
        }

    return (
        <div>

            <div>
                <p className="head-4 dark-H">Property Name</p>

                <div className="search-box mt-2">
                    <input
                        type="text"
                        className="body-S"
                        placeholder="write here"
                        style={{ width: "100%" }}
                        value={filterData?.property_name}
                        onChange={(e) => {
                            handleFilterChange(e.target.value, "property_name");
                        }}
                    />
                </div>
            </div>

            <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

            <div>
                <p className="head-4 dark-H capitalize">Closed Date</p>

                <OptionalOption
                    activeTab="date"
                    onSetLastDate={(value) => handleFilterChange(value, "created_at")}
                    date={filterData?.created_at}
                    onSetDateRange1={(value) => {
                        handleFilterChange(value, "created_start_date");
                    }}
                    date2={filterData?.created_start_date}
                    onSetDateRange2={(value) => handleFilterChange(value, "created_end_date")}
                    date3={filterData?.created_end_date}
                    onClear={() => {
                        onSetFilterData({ ...filterData, created_at: "", created_start_date: "", created_end_date: "" });
                    }}
                />
            </div>

            <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

            <div>
                <FilterFieldHeader
                    title={"Sale Cap Rate"}
                    data={filterData?.min_contract_cap_rate}
                    type="to"
                    symbol={"  to  "}
                    data2={filterData?.max_contract_cap_rate}
                    handleCross={() => {
                        onSetFilterData({ ...filterData, min_contract_cap_rate: "", max_contract_cap_rate: "" });
                    }}
                />

                <div className="flex flex-row mt-2">
                    <div className="w-[50%]">
                        <InputWithIcon icon={percentage} type="number" min={0} placeholder="min rate" value={filterData?.min_contract_cap_rate} onChange={(e) => handleFilterChange(e.target.value, "min_contract_cap_rate")} />
                    </div>
                    <div className="w-[50%]">
                        <InputWithIcon icon={percentage} type="number" min={0} placeholder="max rate" value={filterData?.max_contract_cap_rate} onChange={(e) => handleFilterChange(e.target.value, "max_contract_cap_rate")} />
                    </div>
                </div>
            </div>

            <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

            <div>
                <FilterFieldHeader
                    title={"Sale price"}
                    data={filterData?.min_contract_price}
                    type="to"
                    symbol={"  to  "}
                    data2={filterData?.max_contract_price}
                    handleCross={() => {
                        onSetFilterData({ ...filterData, min_contract_price: "", max_contract_price: "" });
                    }}
                />

                <div className="flex flex-row mt-2">
                    <div className="w-[50%]">
                        <InputWithIcon icon={percentage} type="number" min={0} placeholder="min rate" value={filterData?.min_contract_price} onChange={(e) => handleFilterChange(e.target.value, "min_contract_price")} />
                    </div>
                    <div className="w-[50%]">
                        <InputWithIcon icon={percentage} type="number" min={0} placeholder="max rate" value={filterData?.max_contract_price} onChange={(e) => handleFilterChange(e.target.value, "max_contract_price")} />
                    </div>
                </div>
            </div>





        </div>
    );
};

export default ClosedFilterData;
